module.exports = __webpack_public_path__ + "static/media/a-que-afp-pertenezco.22f2bf0f.png";